import { ReactElement, useState } from "react";
import { Table, TableBody, TableCell, TableHead, TableRow, TableSortLabel } from "@mui/material";
import { getComparator, stableSort } from "../../../system/utils";
import StyledTableRow from "../../../components/styledTableRow";
import { IColumn, INote, Order } from "../../../types";
import TableContainer  from "../../../components/tableContainer";

const columns: IColumn[] = [
  {
    id: "note",
    label: "Note",
    minWidth: 300
  }
];

interface IProps {
  data: INote[];
}

const NotePanel = ({ data }: IProps): ReactElement => {
  const [order, setOrder] = useState<Order>("asc");
  const [orderBy, setOrderBy] = useState<keyof INote>("note");

  const createSortHandler = (property: keyof INote) => () => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  return (
    <div>
      <TableContainer>
        <Table stickyHeader={true} size={"small"}>
          <TableHead>
            <TableRow>
              {columns.map((column) =>
                <TableCell
                  className="table-header"
                  key={column.id}
                  align={column.align}
                  style={{ minWidth: column.minWidth }}
                  sortDirection={orderBy === column.id ? order : false}>
                  <TableSortLabel
                    active={orderBy === column.id}
                    direction={orderBy === column.id ? order : "asc"}
                    onClick={createSortHandler(column.id as keyof INote)}
                  >
                    {column.label}
                    {orderBy === column.id
                      ? <span className="cell-visuallyHidden">
                        {order === "desc" ? "sorted descending" : "sorted ascending"}
                      </span>
                      : null}
                  </TableSortLabel>
                </TableCell>
              )}
            </TableRow>
          </TableHead>
          <TableBody>
            {stableSort<INote>(data, getComparator(order, orderBy))
              .map((row, index) => {
                return (
                  <StyledTableRow hover={true} role="checkbox" tabIndex={-1} key={`alarm-row-${index}`}>
                    {columns.map((column: IColumn) => {
                      const value = row[column.id as keyof INote];

                      return (
                        <TableCell key={column.id} align={column.align}>
                          {value}
                        </TableCell>
                      );
                    })}
                  </StyledTableRow>
                );
              })}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
};

export default NotePanel;
